import React from 'react';
import { SvgProps } from 'apps/sigma2-ui/src/components/svg/types';
import { toSvgColor } from 'apps/sigma2-ui/src/components/svg/types';

export const BookmarkIcon: React.FC<SvgProps> = (props) => {
  const fillColor = toSvgColor('currentColor', props);

  return (
    <g {...(props.group ?? {})}>
      <path
        d="M0.812336 0C0.363931 0 0 0.355986 0 0.796377V15.2038C0 15.512 0.181153 15.7924 0.465478 15.9238C0.749802 16.0552 1.08612 16.0145 1.32818 15.8186L5.99919 12.0516L10.6702 15.8186C10.9139 16.0145 11.2502 16.0544 11.5329 15.9238C11.8172 15.7924 11.9984 15.5112 11.9984 15.2038L12 0.796377C12 0.356782 11.6369 0 11.1877 0H0.812336Z"
        fill={fillColor}
      />
    </g>
  );
};

export const BookmarkIconSvg: React.FC<SvgProps> = (props) => {
  return (
    <svg
      data-testid="bookmark-icon"
      width="16"
      height="16"
      viewBox="0 0 12 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...(props.svg ?? {})}
    >
      <BookmarkIcon {...props} />
    </svg>
  );
};
